import { styled } from "styled-components";
import { Button } from "@/components/ui/Button.tsx";

export const ToolbarButton = styled(Button)`
    font-weight: 700;
    width: 40px;
    height: 40px;
    border: 1px solid #CECECE;
    background: #fff;
    padding: 0;
    
    svg {
        min-width: 24px;
    }
`
